import {
  INVALID_PHONE,
  MISSING_PHONE,
  MISSING_ADDRESS_FIRSTNAME,
  INVALID_ADDRESS_FIRSTNAME,
  MISSING_ADDRESS_LASTNAME,
  INVALID_ADDRESS_LASTNAME,
  MISSING_CARD_NUMBER,
  UNSUPPORTED_CREDIT_BRAND,
  MISSING_CARD_TYPE,
  INVALID_CARD_NUMBER,
  INVALID_DEBIT_DISABLED_FOR_CREDIT,
  INVALID_CARD_TYPE,
  MISSING_POSTAL_CODE,
  INVALID_POSTAL_CODE,
  MISSING_ADDRESS_LINE1,
  INVALID_ADDRESS_LINE1,
  MISSING_CITY,
  INVALID_CITY,
  MISSING_COUNTRY_ABBREVIATION,
  INVALID_COUNTRY_CODE,
  INVALID_COUNTRY_ABBREVIATION,
  MISSING_STATE_ABBREVIATION,
  INVALID_STATE_ABBREVIATION,
  MISSING_CARD_EXPIRY_DETAILS,
  INVALID_CARD_EXPIRATION_YEAR,
  INVALID_CARD_EXPIRATION_IN_PAST,
  INVALID_CARD_EXPIRATION_MONTH,
  INVALID_UNIT,
  FAILURE_DEBIT_AVS_CHECK,
  CLAWBACK_OPTION_EXPIRES_BEFORE_EVENT,
} from '../../../constants/error-codes';

export default {
  phone: [
    INVALID_PHONE,
    MISSING_PHONE,
  ],
  firstName: [
    MISSING_ADDRESS_FIRSTNAME,
    INVALID_ADDRESS_FIRSTNAME,
  ],
  lastName: [
    MISSING_ADDRESS_LASTNAME,
    INVALID_ADDRESS_LASTNAME,
  ],
  cardNumber: [
    MISSING_CARD_NUMBER,
    UNSUPPORTED_CREDIT_BRAND,
    MISSING_CARD_TYPE,
    INVALID_CARD_NUMBER,
    INVALID_DEBIT_DISABLED_FOR_CREDIT,
    INVALID_CARD_TYPE,
  ],
  zipCode: [
    MISSING_POSTAL_CODE,
    INVALID_POSTAL_CODE,
    FAILURE_DEBIT_AVS_CHECK,
  ],
  address1: [
    MISSING_ADDRESS_LINE1,
    INVALID_ADDRESS_LINE1,
  ],
  city: [
    MISSING_CITY,
    INVALID_CITY,
  ],
  countryAbbreviation: [
    MISSING_COUNTRY_ABBREVIATION,
    INVALID_COUNTRY_CODE,
    INVALID_COUNTRY_ABBREVIATION,
  ],
  stateAbbreviation: [
    MISSING_STATE_ABBREVIATION,
    INVALID_STATE_ABBREVIATION,
  ],
  expirationYear: [
    MISSING_CARD_EXPIRY_DETAILS,
    INVALID_CARD_EXPIRATION_YEAR,
    INVALID_CARD_EXPIRATION_IN_PAST,
    CLAWBACK_OPTION_EXPIRES_BEFORE_EVENT,
  ],
  expirationMonth: [
    INVALID_CARD_EXPIRATION_MONTH,
    CLAWBACK_OPTION_EXPIRES_BEFORE_EVENT,
  ],
  unit: [
    INVALID_UNIT,
  ],
};
